import React, { useState } from "react";
import PropTypes from "prop-types";
import { Avatar } from "antd";

// Profile images are static files served from the bare host (REACT_APP_Base_URL),
// not the /api base.
const BASE = process.env.REACT_APP_Base_URL || "";

const initialsOf = (name) =>
  (name || "?")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

// Build a usable URL from a stored profileImage path. Handles absolute URLs and
// relative paths with or without a leading slash. Returns null when empty.
const photoUrl = (img) => {
  if (!img) return null;
  if (/^https?:\/\//i.test(img)) return img;
  return `${BASE}${img.startsWith("/") ? "" : "/"}${img}`;
};

// Employee avatar that shows the profile photo when it loads and falls back to
// the person's initials otherwise - so a missing/broken photo never shows the
// browser's broken-image icon.
function EmployeeAvatar({ name, profileImage, size = 36, style, className }) {
  const [failed, setFailed] = useState(false);
  const url = failed ? null : photoUrl(profileImage);
  return (
    <Avatar
      size={size}
      src={url || undefined}
      onError={() => {
        setFailed(true);
        return false;
      }}
      className={className}
      style={{ backgroundColor: "#2E7D32", color: "#fff", fontWeight: 600, ...style }}
    >
      {!url && initialsOf(name)}
    </Avatar>
  );
}
EmployeeAvatar.propTypes = {
  name: PropTypes.string,
  profileImage: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
  className: PropTypes.string,
};

export default EmployeeAvatar;
